import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'caseGroupCreationCodesPipe',
   pure: true
})
export class CaseGroupCreationCodesPipePipe implements PipeTransform {

  transform(codesData: any[], searchTerm: string): any[] {
    if (!codesData || !searchTerm) { return codesData; }

    // codesData.forEach(element => {
    //   if(element.Desc==null ){
    //     element.Desc="";
    //   }
    
    // });


    return codesData.filter(ad =>
     
    
      ad.name.toLowerCase().indexOf(searchTerm.toLowerCase().trim()) !== -1
      ||
      ad.desc.toLowerCase().indexOf(searchTerm.toLowerCase().trim())!==-1
   


    );
  }

}
